import React from "react";

export default function PrivacyPolicy() {
    return (
        <div className="agreement mx-auto max-w-3xl p-6 leading-7 text-gray-800">
            <style>{`
  .agreement { text-align: justify; }
  .agreement h1 { font-size: 1.75rem; font-weight: 700; margin: 1.25rem 0 .5rem; }
  .agreement h2 { font-size: 1.25rem; font-weight: 700; margin: 1rem 0 .25rem; }
  .agreement p { margin: .5rem 0; }
  .agreement ul, .agreement ol { margin: .5rem 0 .75rem 1.25rem; }
  .agreement ol { list-style-type: decimal; padding-left: 1.5rem; }
  .agreement ul { list-style-type: disc; padding-left: 1.5rem; }
  .agreement a { text-decoration: underline; }
    .agreement {
    max-height: min(70vh, 480px);  
    overflow-y: auto;              
  }
`}</style>
            <p>
                <strong>How TruCarbon Processes your Personal Data/Company Information</strong>
            </p>
            <p>
                <strong>Introduction</strong>
            </p>
            <p>
                PT Solusi Transisi Iklim (“
                <strong>TruCarbon</strong>
                ”), respects your rights to privacy protection regarding the processing, collection, use, disclosure,
                and handling of personal data/company information. This Privacy Policy outlines the practices adopted by
                TruCarbon for the purpose of safeguarding your privacy, whilst instilling confidence in how we manage
                the personal data/company information you entrust to us. By utilizing the TruCarbon website or providing
                personal information to TruCarbon, you consent to the collection, use, disclosure, and/or transfer
                (including cross-border transfer) of your personal information in accordance with this Privacy Policy.
            </p>
            <p>
                <strong>How we collect your personal data/company information</strong>
            </p>
            <p>
                Personal information is any information that can be used to identify you. TruCarbon may collect
                information about you (such as name, e-mail, phone number, date of birth and postal address), in the
                following ways:
            </p>
            <ul>
                <li>
                    Through our services provided from{" "}
                    <a href="https://trucarbon.co" target="_blank" rel="noreferrer">
                        https://trucarbon.co
                    </a>{" "}
                    and other affiliated TruCarbon Sites;
                </li>
                <li>
                    When you contact us to enquire or complain concerning our services;
                </li>
                <li>
                    Through information which is provided or obtained manually by TruCarbon from you.
                </li>
            </ul>
            <p>
                We will retain all information for a period that refers to the relevant personal data protection laws in
                force in Indonesia.
            </p>
            <p>
                <strong>How we share your personal data/company information</strong>
            </p>
            <p>
                We may share information about you with third parties in certain circumstances including in the
                following situations:
            </p>
            <ul>
                <li>
                    <strong>TruCarbon Group</strong>
                    . We may share information with other companies within the TruCarbon group, including our parent
                    company, subsidiaries, and affiliates.
                </li>
                <li>
                    <strong>Service Providers and Merchants</strong>
                    . We may share information with companies or merchants who provide services to us and the users.
                    These services may include but are not limited to, assisting us in fulfilling your service requests,
                    managing our databases, conducting research and analysis on our customers, preparing and
                    distributing communications, or addressing inquiries.
                </li>
                <li>
                    <strong>Law Enforcement</strong>
                    . In cases where we reasonably believe that certain activities are unlawful or could assist in a law
                    enforcement investigation, we may report such activities to the appropriate law enforcement
                    agencies. Furthermore, we retain the right to disclose your information to law enforcement agencies
                    if we determine, at our sole discretion, that you have violated our policies, or if such disclosure
                    is necessary to safeguard the rights, property, or safety of TruCarbon or any other individuals.
                </li>
                <li>
                    <strong>As Permitted by Law</strong>
                    . We may disclose your information to others as mandated or authorized by law. This could involve
                    sharing your information with government entities or third parties in response to subpoenas, court
                    orders, or other legal processes. We may also exercise this option when we believe it is necessary
                    to assert our legal rights, protect ourselves against legal claims that have been made, or safeguard
                    against potential legal claims that we, at our sole discretion, determine might arise.
                </li>
            </ul>
            <p>
                <strong>Changes to this Privacy Policy</strong>
            </p>
            <p>
                The personal information you provide will be utilized in accordance with the Privacy Policy applicable
                at the time of collection. In the event of any changes to our Privacy Policy, we will promptly update
                our websites to ensure that you remain informed about the information we collect, how we utilize it, and
                under what circumstances, if any, we disclose it.
            </p>
            <p>
                For more information on how TruCarbon processes your personal data/company information, please refer to
                our Privacy Policy here.
            </p>
            <p>
                <strong>PRIVACY POLICY</strong>
            </p>
            <p>
                <strong>(FULL VERSION)</strong>
            </p>
            <p>
                <em>This Privacy Policy is part of the TruCarbon Website and Services User Agreement (“</em>
                <strong><em>User Agreement</em></strong>
                <em>”). The use of the TruCarbon Site and any features and/or services available in the TruCarbon
                    Application, Sites, sub-domains and/or affiliated services is a form of User consent to the User
                    Agreement and the Privacy Policy. Therefore, the User needs to read this Privacy Policy carefully to
                    ensure that the User fully understands before registering, accessing, and/or using the TruCarbon
                    Application and/or TruCarbon Site and Services.</em>
            </p>
            <ol>
                <li>
                    By registering on the login page and/ or

                    using the TruCarbon Site and/or the TruCarbon Application, the User is deemed to have read and
                    understand this Privacy Policy and therefore the User gives his consent to us to collect, process,
                    analyze, display, send, open, store, modify, delete, manage and/or use the Personal Data.
                </li>
                <li>
                    “
                    <strong>Personal Data</strong>
                    ” is all data, information, and/or information in any form that can identify User, including full
                    name, identity card and including but not limited to data contained therein, passport and all data,
                    date of birth, type of gender, marital status, height/weight, blood type and rhesus blood,
                    electronic mail address (e-mail), mobile phone number - including but not limited to - IP address,
                    location information, save your location, display your location, your device data, contact number on
                    your smartphone, IMEI number, and including agreeing to provide such data to other applications that
                    TruCarbon have made that have been attached and or linked to the TruCarbon Application and/or
                    TruCarbon Site that the User use on their device, data concerning the information regarding User’s
                    transaction activities on the TruCarbon Application and/or TruCarbon Site, and other data that is
                    classified as personal data both when the User start using the application and/or as long as the
                    User use the TruCarbon Application and/or TruCarbon Site.
                </li>
                <li>
                    “
                    <strong>Company</strong>
                    ” means any legal entity whether established in Indonesia or outside of Indonesia which uses the
                    Application and/or Site and any features and/or services provided by TruCarbon
                    .
                </li>
                <li>
                    “
                    <strong>Company Information</strong>
                    ” means all and any information, knowledge or data pertaining to a Company as a user of the
                    TruCarbon Site and/or the TruCarbon, Application, including, Name, electronic mail address (e-mail),
                    mobile phone number, number of users, address of the Company, Company methods on managing emissions
                    and company information that is not publicly available, as well as data concerning the information
                    regarding the Company’s transaction activities on the TruCarbon Application and/or TruCarbon Site,
                    and other data that is classified as company information which is collected in the period of use of
                    the Company.
                </li>
                <li>
                    TruCarbon collects User's Personal Data/Company Information for the intention to process User
                    transactions, manage and expedite the application process, as well as other purposes as long as
                    permitted by laws and regulations.
                </li>
                <li>
                    TruCarbon uses Personal Data/Company Information collected from the User for the following purposes
                    as well as such other purposes as are permitted by applicable data protection laws:
                </li>
                <li>
                    to identify and register the User as a user on the application/website and to administer, verify,
                    deactivate, or manage your account;
                </li>
                <li>
                    to process all forms of requests, activities, payments, and transactions made by the User through
                    the TruCarbon Application and/or TruCarbon Site;
                </li>
                <li>
                    to assist the User when communicating with the merchant;
                </li>
                <li>
                    to supervise and/or investigate suspicious transactions;
                </li>
                <li>
                    to offer or provide services from TruCarbon’s affiliates or partners;
                </li>
                <li>
                    to enable service providers/merchants to provide the User with such of the services as requested;
                </li>
                <li>
                    to monitor and analyse user activities, behaviour, and demographic data including trends and usage
                    of the various services available on the TruCarbon Application;
                </li>
                <li>
                    in certain circumstances, TruCarbon may need to use or disclose User’s Personal Data/Company
                    Information for law enforcement purposes in the event of fraud or data theft and/or other suspicious
                    things.
                </li>
            </ol>
            <p>
                Further description concerning how TruCarbon uses your Personal Data/Company Information shall be
                further explain in the “
                <strong>THE USE OF PERSONAL DATA/COMPANY INFORMATION</strong>
                ” section below.
            </p>
            <ol>
                <li>
                    TruCarbon strives to ensure that the information that User provide to TruCarbon is safe and cannot
                    be used by irresponsible parties. For the security of User data, TruCarbon strongly recommends that
                    User always update applications and software and does not disclose User passwords to any party.
                </li>
                <li>
                    The User hereby agrees that TruCarbon may store their Personal Data/Company Information on a server
                    located in a data centre directly managed by TruCarbon. The use of Personal Data/Company Information
                    in connection with the use of the TruCarbon Application and/or TruCarbon Site will continue to be
                    governed by this Privacy Policy in accordance with the prevailing laws and regulations in the
                    Republic of Indonesia.
                </li>
                <li>
                    This Privacy Policy is governed by the laws of the Republic of Indonesia and the User is required to
                    comply with all applicable regulations in the Republic of Indonesia.
                </li>
            </ol>
            <p>
                <strong>PERSONAL DATA/COMPANY INFORMATION ACCURACY</strong>
            </p>
            <ol>
                <li>
                    TruCarbon may need the User’s Personal Data/Company Information to process transactions. The
                    Personal Data/Company Information that the User provides to TruCarbon must be as accurate as
                    possible and not misleading. The User shall update and notify TruCarbon of any changes to User
                    Personal Data/Company Information. In the event of a data update, TruCarbon will update the Personal
                    Data/Company Information no later than 3 x 24 hours from the time TruCarbon receives the request for
                    data update and/or correction. By using the TruCarbon Application and/or TruCarbon Site, the User
                    waives TruCarbon from any claims, suits, damages, and/or claims in connection with the failure of
                    transaction processing on the TruCarbon Application and/or TruCarbon Site caused by any inaccuracy
                    of the Personal Data/Company Information that the User provides to TruCarbon.
                </li>
                <li>
                    If the User is below 18 years old, has not married, or is under guardianship, then the User needs
                    the consent of the User’s parents, guardians, or legal guardians to provide Personal
                    Data to TruCarbon. When User Personal Data is provided to TruCarbon, User hereby represents and
                    warrants that the User parent, legal guardian, or guardian has consented to the processing of User
                    Personal Data and personally accepts and agrees to be bound by this Privacy Policy and is
                    responsible for User actions.
                </li>
                <li>
                    When the User provides Personal Data relating to other people, such as User’s spouse, family
                    members, and/or friends, it also means that the User represents and guarantee that the User has the
                    authority and consent of the owner of the Personal Data to provide their Personal Data to TruCarbon
                    for use following the purposes described in this Privacy Policy.
                </li>
                <li>
                    During a Company’s use of both the TruCarbon Application or the TruCarbon Site, the User
                    representing the Company warrants that it has obtained all of the Company approvals (both internal
                    and external) to provide TruCarbon with Company Information for processing in accordance with the
                    provisions set out in this Privacy Policy.
                </li>
            </ol>
            <p>
                <strong>USER SELECTION AND TRANSPARENCY</strong>
            </p>
            <ol>
                <li>
                    Mobile devices generally have settings so that the TruCarbon Application and/or TruCarbon Site
                    cannot access certain data without the consent of the User.
                </li>
                <li>
                    The User can access and change information in the form of e-mail address, telephone number, date of
                    birth, gender, address list, payment method, and bank account through the settings feature.
                </li>
            </ol>
            <p>
                <strong>COLLECTION OF PERSONAL DATA/COMPANY INFORMATION</strong>
            </p>
            <ol>
                <li>
                    Provision of the User’s Personal Data/Company Information is voluntary. However, if the User does
                    not provide TruCarbon with the User’s Personal Data/Company Information, TruCarbon cannot provide
                    services or products or process payments from the User.
                </li>
                <li>
                    Collection of User Personal Data/Company Information occurs when the User creates or updates an
                    Account or any other time, if necessary, from time to time. TruCarbon will collect the User’s
                    Personal Data/Company Information every time the User access or use the TruCarbon Application and/or
                    TruCarbon Site.
                </li>
                <li>
                    If the User utilizes a virtual account provided by TruCarbon to receive electronic money and/or
                    electronic wallet payment from a payer, whether the User is a service provider or merchant, we may
                    collect certain information related to your utilization including but not limited to service
                    transacted, amount the User collects from every transaction, withdrawal or settlement account
                    details and withdrawal or settlement history.
                </li>
                <li>
                    If the User utilizes and/or when a payment is made through the payment card or account that the User
                    add in the TruCarbon Application, TruCarbon may collect certain information related to the
                    transaction history (including receiver details), bill details, invoice details, and phone number
                    details.
                </li>
            </ol>
            <p>
                <strong>THE USE OF PERSONAL DATA/COMPANY INFORMATION</strong>
            </p>
            <p>
                The purpose of TruCarbon to process, analyse, and/or use User Personal Data/Company Information in
                accordance with and permitted by the applicable laws and regulations, as follows:
            </p>
            <ol>
                <li>
                    Identify and register the User as a TruCarbon Application and/or TruCarbon Site user as well as
                    verify, deactivate, or manage the User account, including the Know Your Customer process;
                </li>
                <li>
                    Process and manage TruCarbon Application and/or TruCarbon Site and related components of TruCarbon
                    Application and/or TruCarbon Site;
                </li>
                <li>
                    Prevent, detect, investigate, and reduce the occurrence of criminal acts or prohibited, illegal, or
                    fraudulent acts, which may occur in the use of the TruCarbon Application and/or TruCarbon Site
                    including but not limited to fraud, embezzlement, theft, and money laundering;
                </li>
                <li>
                    Develop, add, and provide services and/or products to meet the User’s needs;
                </li>
                <li>
                    Improve the implementation of research on demographic data of TruCarbon Application and/or TruCarbon
                    Site;
                </li>
                <li>
                    Send information that TruCarbon considers useful to the User after the User has given his consent to
                    TruCarbon that the User does not mind being contacted about TruCarbon services;
                </li>
                <li>
                    Use the User’s Personal Data/Company Information for internal administrative purposes, including but
                    not limited to audit, data analysis, records in database data;
                </li>
                <li>
                    Communicate with the User in connection with all matters regarding the TruCarbon Application,
                    TruCarbon Site and/or features thereof, while at the same time helping to maintain the safety,
                    security, and continuity of the TruCarbon Application and/or TruCarbon Site, TruCarbon services,
                    and/or features thereof;
                </li>
                <li>
                    Enable TruCarbon to provide and process the services the User request or the transactions the User
                    make.
                </li>
                <li>
                    For accounting and financial reporting, by accessing the users records.
                </li>
                <li>
                    For the development of TruCarbon’s services such as using machine learning technology and the use of
                    data for calculating user’s emissions based on accounting data.
                </li>
                <li>
                    To Collect information on new formula of emission factors of users for other users of the TruCarbon
                    Application and/or TruCarbon Site.
                </li>
                <li>
                    Data Accumulation from multiple users to be used to improve the TruCarbon Application and/or
                    TruCarbon Site, TruCarbon services, and/or features thereof.
                </li>
            </ol>
            <p>
                <strong>THIRD PARTY COOPERATIONS</strong>
            </p>
            <p>
                In maintaining the TruCarbon application/website, TruCarbon cooperates/uses the services of third party
                companies which assist in the processing of the users Personal Data/Company Information.
            </p>
            <p>
                <strong>LINKS TO THIRD PARTY SITES</strong>
            </p>
            <p>
                By using the TruCarbon Application and/or TruCarbon Site and the approval of this Privacy Policy, the
                User has given TruCarbon permission to link to third-party sites. However, TruCarbon is not responsible
                for the acquisition, collection, processing, analysis, use, storage, display, announcement,
                transmission, dissemination, deletion, and destruction of User Personal Data/Company Information by such
                third parties. Similarly, suppose the User provides information directly to these sites. In that case,
                the privacy policies, and terms of service on those sites will apply, and TruCarbon is not responsible
                for these sites’ information processing activities or privacy policies and/ or any losses arising from
                the third party site.
            </p>
            <p>
                <strong>SECURITY, STORAGE, AND DELETION OF USER PERSONAL DATA/COMPANY INFORMATION</strong>
            </p>
            <ol>
                <li>
                    TruCarbon protects any Personal Data/Company Information stored in its systems and protects such
                    data from unauthorized access, use, modification, and retrieval, including passwords and OTP codes.
                </li>
                <li>
                    Although TruCarbon has used its best efforts to protect the User's Personal Data/Company
                    Information, however, TruCarbon cannot guarantee 100% data security, and is at the User's own risk.
                </li>
                <li>
                    Whenever the User uses the TruCarbon Application or visits TruCarbon Site, certain information may
                    also be collected on an automated basis using cookies. Cookies are small application files stored on
                    the User’s computer or mobile device. We use cookies to track user activity to enhance user
                    interface and experience. Most mobile devices and internet browsers support the use of cookies; but
                    the User may adjust the settings on their mobile device or internet browser to reject several types
                    of certain cookies or certain specific cookies. The mobile device and/or browser would also enable
                    the User to delete at any time whatever cookies have previously been stored. However, doing so may
                    affect the functionalities available on the TruCarbon Application or TruCarbon Site.
                </li>
                <li>
                    TruCarbon will delete or anonymize the User's Personal Data/Company Information that is under
                    TruCarbon's control if the Personal Data/Company Information is no longer needed to fulfil the
                    purpose for which it was collected.
                </li>
            </ol>
            <p>
                <strong>COMPLAINTS REGARDING USER PERSONAL DATA/COMPANY INFORMATION PROTECTION</strong>
            </p>
            <ol>
                <li>
                    If the User has concerns about TruCarbon’s handling or treatment of the User’s Personal Data/Company
                    Information or believes that his or her privacy was violated. In that case, the User may contact
                    TruCarbon through the TruCarbon service or the TruCarbon contact listed in this Privacy Policy by
                    explaining the identity and complaint.
                </li>
                <li>
                    TruCarbon will investigate the User complaints and respond to such complaints within a reasonable
                    time after receiving complaints submitted by the User.
                </li>
            </ol>
            <p>
                <strong>ENTIRE AGREEMENT</strong>
            </p>
            <p>
                Unless expressly agreed in writing by the Parties, this Agreement constitutes the entire agreement
                between the Parties with respect to the matters handled here and supersedes any previous agreement
                between the Parties with respect to such matters.
            </p>
            <p>
                <strong>CHANGES TO PRIVACY POLICY</strong>
            </p>
            <ol>
                <li>
                    TruCarbon may at any time change, update, and/or add part or all of the provisions of this Privacy
                    Policy, in accordance with TruCarbon’s business going forward, and/or changes to applicable laws and
                    regulations. If such changes or additions are made by TruCarbon, TruCarbon will notify the User
                        through a notification sent through the TruCarbon Application and/or the{" "}
                    <a href="https://trucarbon.co" target="_blank" rel="noreferrer">
                        <span>https://trucarbon.co</span>
                    </a>{" "}
                    website, and/or to the User’s email address.
                </li>
                <li>
                    By continuing to use the TruCarbon Application and/or TruCarbon Site, the User has agreed to the
                    changes, updates, and/or additions that TruCarbon has made to this Privacy Policy.
                </li>
                <li>
                    If the User continues to use the TruCarbon Application and/or TruCarbon Site after reading this
                    Privacy Policy, the User has agreed to this Privacy Policy – including its amendments – and may
                    continue to use the Application.
                </li>
            </ol>
            <p>
                <strong>TRANSFER OF BUSINESS</strong>
            </p>
            <p>
                In the event of a change of control or a change of ownership of all or part of TruCarbon or the Company,
                including the site, the User’s Personal Data/Company Information may/will be part of the transfer of
                such assets. TruCarbon will further inform the User in the event of a merger, separation, acquisition,
                consolidation or dissolution.
            </p>
            <p>
                <strong>PRIORITY ORDER</strong>
            </p>
            <p>
                If the User/Company has agreed to our User Agreement, in the event of any discrepancy between the User
                Agreement and this Privacy Policy with regard to the use of privacy data, the User Agreement shall
                prevail.
            </p>
            <p>
                <strong>CONTACT US</strong>
            </p>
            <p>
                If the User has any questions, comments, or claims regarding this privacy policy or wishes to obtain
                access or correct his/her Personal Data/Company Information, please contact TruCarbon customer service
                    via{" "}
                <a href="mailto:contact@trucarbon.co" target="_blank" rel="noreferrer">
                    contact@trucarbon.co
                </a>{" "}
            </p>
            <p>
                <strong>Cara TruCarbon Memproses Data Pribadi/Informasi Perusahaan Anda</strong>
            </p>
            <p>
                <strong>Pendahuluan</strong>
            </p>
            <p>
                PT Solusi Transisi Iklim ("
                <strong>TruCarbon</strong>
                "), menjunjung hak Anda atas perlindungan privasi terkait pemrosesan, pengumpulan, penggunaan,
                pengungkapan, dan penanganan data pribadi/informasi perusahaan. Kebijakan Privasi ini menguraikan
                praktik yang diadopsi oleh kami untuk tujuan melindungi privasi Anda, serta menanamkan kepercayaan pada
                cara kami mengelola data/informasi pribadi yang Anda percayakan kepada kami. Dengan memanfaatkan situs
                web TruCarbon atau memberikan informasi pribadi kepada TruCarbon, Anda menyetujui pengumpulan,
                penggunaan, pengungkapan, dan/atau transfer (termasuk transfer lintas batas) data/informasi pribadi Anda
                sesuai dengan Kebijakan Privasi ini.
            </p>
            <p>
                <strong>Bagaimana kami mengumpulkan data pribadi/informasi perusahaan Anda</strong>
            </p>
            <p>
                Data/informasi pribadi adalah informasi apa pun yang dapat digunakan untuk mengidentifikasi Anda.
                TruCarbon dapat mengumpulkan informasi mengenai Anda (seperti nama, email, nomor telepon, tanggal lahir
                dan alamat pos), dengan cara berikut:
            </p>
            <ul>
                <li>
                    Melalui jasa kami yang tersedia dari{" "}
                    <a href="https://trucarbon.co" target="_blank" rel="noreferrer">
                        https://trucarbon.co
                    </a>{" "}
                    serta Situs afiliasi dari TruCarbon;
                </li>
                <li>
                    Ketika Anda menghubungi kami untuk menanyakan atau mengeluh tentang layanan kami;
                </li>
                <li>
                    Melalui informasi yang diberikan atau di diperoleh secara manual oleh TruCarbon dari Anda.
                </li>
            </ul>
            <p>
                Kami akan menyimpan semua informasi untuk jangka waktu yang sesuai dengan undang-undang perlindungan
                data pribadi yang relevan yang berlaku di Indonesia.
            </p>
            <p>
                <strong>Cara kami membagikan data pribadi/informasi perusahaan Anda</strong>
            </p>
            <p>
                Kami dapat berbagi informasi tentang Anda dengan pihak ketiga dalam keadaan tertentu termasuk dalam
                situasi berikut:
            </p>
            <ul>
                <li>
                    <strong>Grup TruCarbon</strong>
                    . Kami dapat berbagi informasi dengan perusahaan lain dalam grup TruCarbon, termasuk perusahaan
                    induk, anak perusahaan, dan afiliasi kami.
                </li>
                <li>
                    <strong>Penyedia Layanan dan Merchant</strong>
                    . Kami dapat berbagi informasi dengan perusahaan atau merchant yang memberikan layanan kepada kami
                    dan pengguna. Layanan ini mencakup namun tidak terbatas pada, membantu kami dalam memenuhi
                    permintaan layanan Anda, mengelola basis data kami, melakukan penelitian dan analisis terhadap
                    pelanggan kami, menyiapkan dan mendistribusikan komunikasi, atau menangani pertanyaan.
                </li>
                <li>
                    <strong>Penegakan Hukum</strong>
                    . Dalam kasus di mana kami anggap bahwa kegiatan tertentu melanggar hukum atau dapat membantu dalam
                    penyelidikan penegakan hukum, kami dapat melaporkan kegiatan tersebut kepada otoritas penegak hukum
                    yang berwenang. Selanjutnya, kami memiliki hak untuk mengungkapkan informasi Anda kepada lembaga
                    penegak hukum jika kami menentukan, atas kebijakan kami sendiri, bahwa Anda telah melanggar
                    kebijakan kami, atau jika pengungkapan tersebut diperlukan untuk melindungi hak, properti, atau
                    keselamatan TruCarbon atau individu lainnya.
                </li>
                <li>
                    <strong>Sebagaimana diizinkan oleh hukum</strong>
                    . Kami dapat mengungkapkan informasi Anda kepada orang lain sebagaimana diamanatkan atau diizinkan
                    oleh hukum. Ini dapat melibatkan berbagi informasi Anda dengan entitas pemerintah atau pihak ketiga
                    dalam
                    menanggapi panggilan pengadilan, perintah pengadilan, atau proses hukum lainnya. Kami juga dapat
                    menggunakan opsi ini ketika kami membutuhkan untuk menegaskan hak-hak hukum kami, melindungi diri
                    dari klaim hukum yang telah dibuat, atau melindungi terhadap potensi tuntutan hukum yang kami, atas
                    kebijakan kami sendiri, tentukan mungkin akan timbul.
                </li>
            </ul>
            <p>
                <strong>Perubahan terhadap Kebijakan Privasi ini</strong>
            </p>
            <p>
                Informasi pribadi yang Anda berikan akan digunakan sesuai dengan Kebijakan Privasi yang berlaku pada
                saat pengumpulan. Jika ada perubahan pada Kebijakan Privasi kami, kami akan segera memperbarui situs web
                kami untuk memastikan bahwa Anda tetap mendapat informasi mengenai data/informasi yang kami kumpulkan,
                bagaimana kami menggunakannya, dan dalam keadaan, apabila ada, yang memerlukan kami untuk
                mengungkapkannya.
            </p>
            <p>
                Untuk informasi lebih lanjut tentang bagaimana TruCarbon memproses data pribadi/informasi perusahaan
                Anda, mohon untuk dapat melihat keseluruhan Kebijakan Privasi kami di sini.
            </p>
            <p>
                <strong>KEBIJAKAN PRIVASI</strong>
            </p>
            <p>
                <strong>(VERSI LENGKAP)</strong>
            </p>
            <p>
                <em>Kebijakan Privasi ini merupakan bagian dari Perjanjian Pengguna Website dan Layanan TruCarbon
                    (“</em>
                <strong><em>Perjanjian Pengguna</em></strong>
                <em>”) TruCarbon. Penggunaan Situs TruCarbon dan setiap fitur dan/atau layanan yang tersedia dalam
                    Aplikasi, Situs, sub-domain dan/atau layanan afiliasi TruCarbon merupakan bentuk persetujuan
                    Pengguna terhadap Perjanjian Pengguna dan Kebijakan Privasi ini. Oleh karena itu, Pengguna perlu
                    untuk membaca Kebijakan Privasi ini secara seksama untuk memastikan bahwa Pengguna memahaminya
                    sepenuhnya sebelum mendaftar, mengakses dan/atau menggunakan Aplikasi TruCarbon dan/atau Situs
                    TruCarbon maupun Layanan TruCarbon. </em>
            </p>
            <ol>
                <li>
                    Dengan mendaftarkan diri di halaman login dan/ atau menggunakan Situs TruCarbon dan/atau Aplikasi
                    TruCarbon; maka Pengguna dianggap telah membaca dan memahami Kebijakan Privasi ini dan karenanya
                    Pengguna memberikan persetujuan kepada kami untuk mengumpulkan, mengolah, menganalisis, menampilkan,
                    mengirim, membuka, menyimpan, mengubah, menghapus, mengelola dan/ atau menggunakan Data Pribadi.
                </li>
                <li>
                    “
                    <strong>Data Pribadi</strong>
                    ” mencakup semua data, informasi, dan/atau keterangan dalam bentuk apa pun yang dapat
                    mengidentifikasikan diri Pengguna, termasuk namun tidak terbatas pada : nama lengkap, kartu
                    identitas dan termasuk semua data yang ada di dalamnya, paspor dan seluruh datanya, tanggal lahir,
                    jenis kelamin, status perkawinan, tinggi/berat badan, golongan darah dan rhesus darah, alamat surat
                    elektronik (e-mail), nomor telepon - termasuk namun tidak terbatas pada - IP address, informasi
                    lokasi, menyimpan lokasi Pengguna, menampilkan lokasi Pengguna, data perangkat Pengguna, nomor
                    kontak di smartphone, nomor IMEI, dan termasuk menyetujui pemberian data tersebut ke
                    aplikasi-aplikasi lain yang TruCarbon buat yang telah dilekatkan dan atau dihubungkan dalam Aplikasi
                    TruCarbon dan/atau Situs TruCarbon yang Pengguna pakai pada perangkat Pengguna, data yang menyangkut
                    informasi mengenai kegiatan transaksi Pengguna pada Aplikasi TruCarbon dan/atau Situs TruCarbon, dan
                    data lainnya yang tergolong sebagai data pribadi baik pada saat Pengguna mulai menggunakan Aplikasi
                    TruCarbon dan/atau Situs TruCarbon maupun waktu-waktu seterusnya selama Pengguna menggunakan
                    Aplikasi TruCarbon dan/atau Situs TruCarbon ini.
                </li>
                <li>
                    “
                    <strong>Perusahaan</strong>
                    " berati setiap badan hukum baik yang didirikan di Indonesia maupun di luar Indonesia yang
                    menggunakan Aplikasi dan/atau Situs serta setiap fitur dan/atau layanan yang disediakan oleh
                    TruCarbon.
                </li>
                <li>
                    “
                    <strong>Informasi Perusahaan</strong>
                    ” berarti semua dan setiap informasi, pengetahuan atau data yang berkaitan dengan Perusahaan sebagai
                    pengguna Situs TruCarbon dan/atau Aplikasi TruCarbon, termasuk, Nama, alamat surat elektronik
                    (email), nomor ponsel, jumlah pengguna, alamat Perusahaan, metode Perusahaan dalam mengelola emisi
                    dan informasi perusahaan yang tidak tersedia untuk umum, serta data mengenai informasi mengenai
                    kegiatan transaksi Perusahaan pada Aplikasi TruCarbon dan/atau Situs TruCarbon, dan data lain yang
                    diklasifikasikan sebagai informasi perusahaan yang dikumpulkan pada periode penggunaan Perusahaan.
                </li>
                <li>
                    TruCarbon mengumpulkan Data Pribadi/Informasi Perusahaan Pengguna dengan tujuan untuk memproses
                    transaksi Pengguna, mengelola dan memperlancar proses penggunaan aplikasi, serta tujuan-tujuan
                    lainnya selama diizinkan oleh peraturan perundang-undangan.
                </li>
                <li>
                    TruCarbon menggunakan Data Pribadi/Informasi Perusahaan yang diperoleh dan dikumpulkan dari Pengguna
                    untuk tujuan hal-hal sebagai berikut dan tujuan lain yang diperbolehkan oleh peraturan
                    perundang-undangan mengenai pelindungan data pribadi yang berlaku:
                </li>
                <li>
                    untuk mengidentifikasi dan mendaftarkan Pengguna sebagai pengguna dalam aplikasi/situs dan untuk
                    mengurus, memverifikasi, menonaktifkan, atau mengelola akun Anda;
                </li>
                <li>
                    untuk memproses segala bentuk permintaan, aktivitas, pembayaran maupun transaksi yang dilakukan oleh
                    Pengguna melalui Aplikasi TruCarbon dan/atau Situs TruCarbon;
                </li>
                <li>
                    untuk membantu pengguna pada saat berkomunikasi dengan merchant;
                </li>
                <li>
                    untuk melakukan pengawasan dan/atau melakukan investigasi terhadap transaksi mencurigakan;
                </li>
                <li>
                    untuk menawarkan atau menyediakan layanan dari afiliasi atau mitra TruCarbon;
                </li>
                <li>
                    untuk memungkinkan penyedia layanan/merchant menyediakan Pengguna dengan layanan seperti yang
                    diminta;
                </li>
                <li>
                    untuk memantau dan menganalisis aktivitas pengguna, perilaku, dan data demografis termasuk tren dan
                    penggunaan berbagai layanan yang tersedia di Aplikasi TruCarbon;
                </li>
                <li>
                    dalam keadaan tertentu, TruCarbon mungkin perlu untuk menggunakan atau mengungkap Data
                    Pribadi/Informasi Perusahaan Pengguna untuk tujuan penegakkan hukum dalam hal terjadi penipuan atau
                    pencurian data dan/ atau hal-hal yang mencurigakan lainnya.
                </li>
            </ol>
            <p>
                Deskripsi lebih lanjut terkait bagaimana TruCarbon menggunakan Data Pribadi/Informasi Perusahaan Anda
                akan dijelaskan lebih lanjut pada bagian “
                <strong>PENGGUNAAN DATA PRIBADI/INFORMASI PERUSAHAAN</strong>
                ” di bawah.
            </p>
            <ol>
                <li>
                    TruCarbon berupaya memastikan bahwa informasi yang Pengguna berikan kepada TruCarbon aman dan tidak
                    dapat dipergunakan oleh pihak-pihak yang tidak bertanggung jawab. Untuk keamanan data Pengguna,
                    TruCarbon sangat menyarankan agar Pengguna selalu memperbaharui aplikasi dan perangkat lunak serta
                    tidak mengungkapkan kata sandi Pengguna kepada pihak apapun.
                </li>
                <li>
                    Pengguna dengan ini setuju bahwa TruCarbon dapat menyimpan Data Pribadi pada server yang terletak di
                    pusat data yang dikelola langsung oleh TruCarbon. Pemanfaatan Data Pribadi/Informasi Perusahaan
                    sehubungan dengan penggunaan Aplikasi TruCarbon
                    dan/atau Situs TruCarbon akan terus diatur oleh Kebijakan Privasi ini sesuai dengan peraturan
                    perundangan-undangan yang berlaku di Republik Indonesia.
                </li>
                <li>
                    Kebijakan Privasi ini diatur berdasarkan hukum Negara Republik Indonesia dan Pengguna diwajibkan
                    tunduk kepada semua peraturan yang berlaku di Republik Indonesia.
                </li>
            </ol>
            <p>
                <strong>KEAKURATAN DATA PRIBADI/INFORMASI PERUSAHAAN</strong>
            </p>
            <ol>
                <li>
                    TruCarbon membutuhkan Data Pribadi/Informasi Perusahaan Pengguna untuk dapat melakukan pemrosesan
                    transaksi. Data Pribadi/Informasi Perusahaan yang Pengguna berikan kepada TruCarbon haruslah
                    seakurat mungkin dan tidak menyesatkan. Pengguna harus memperbaharui dan memberitahukan kepada
                    TruCarbon apabila ada perubahan terhadap Data Pribadi/Informasi Perusahaan Pengguna. Dalam hal
                    terjadinya pembaharuan data, TruCarbon akan memperbarui Data Pribadi/Informasi Perusahaan paling
                    lambat 3 x 24 jam terhitung sejak TruCarbon menerima permintaan pembaruan dan/atau perbaikan data.
                    Dengan menggunakan Aplikasi TruCarbon dan/atau Situs TruCarbon, berarti Pengguna membebaskan
                    TruCarbon dari setiap tuntutan, gugatan, ganti rugi, dan/atau klaim sehubungan dengan kegagalan
                    pemrosesan transaksi pada Aplikasi TruCarbon dan/atau Situs TruCarbon yang disebabkan oleh
                    ketidakakuratan Data Pribadi/Informasi Perusahaan yang Pengguna berikan kepada TruCarbon.
                </li>
                <li>
                    Apabila Pengguna belum berusia 18 tahun, belum menikah atau berada di bawah perwalian atau
                    pengampuan maka Pengguna memerlukan persetujuan dari orang tua, wali atau pengampu Pengguna yang sah
                    untuk memberikan Data Pribadi kepada TruCarbon. Saat Data Pribadi Pengguna tersebut diberikan kepada
                    TruCarbon, Pengguna dengan ini menyatakan dan menjamin bahwa orang tua, wali yang sah atau pengampu
                    Pengguna telah menyetujui pemrosesan Data Pribadi Pengguna tersebut dan secara pribadi menerima dan
                    setuju untuk terikat oleh Kebijakan Privasi ini dan bertanggung jawab atas tindakan Pengguna.
                </li>
                <li>
                    Saat Pengguna memberikan Data Pribadi yang berkaitan dengan orang lain, misalnya pasangan, anggota
                    keluarga, dan/atau teman Pengguna, berarti pula Pengguna menyatakan dan menjamin bahwa Pengguna
                    telah memiliki wewenang dan persetujuan dari pemilik Data Pribadi tersebut untuk memberikan Data
                    Pribadi mereka kepada TruCarbon untuk digunakan sesuai dengan tujuan-tujuan yang diuraikan dalam
                    Kebijakan Privasi ini.
                </li>
                <li>
                    Selama penggunaan Aplikasi TruCarbon maupun Situs TruCarbon oleh Perusahaan, Pengguna yang mewakili
                    Perusahaan menjamin telah memperoleh segala persetujuan Perusahaan (baik internal maupun eksternal)
                    untuk memberikan Informasi Perusahaan kepada TruCarbon untuk dapat diproses sesuai dengan ketentuan
                    yang tercantum dalam Kebijakan Privasi ini.
                </li>
            </ol>
            <p>
                <strong>PILIHAN PENGGUNA DAN TRANSPARANSI</strong>
            </p>
            <ol>
                <li>
                    Perangkat seluler pada umumnya memiliki pengaturan sehingga Aplikasi TruCarbon maupun Situs
                    TruCarbon tidak dapat mengakses data tertentu tanpa persetujuan dari Pengguna.
                </li>
                <li>
                    Pengguna dapat mengakses dan mengubah informasi berupa alamat e-mail, nomor telepon, tanggal lahir,
                    jenis kelamin, daftar alamat, metode pembayaran, dan rekening bank melalui fitur pengaturan
                </li>
            </ol>
            <p>
                <strong>PENGUMPULAN DATA PRIBADI/INFORMASI PERUSAHAAN</strong>
            </p>
            <ol>
                <li>
                    Penyediaan Data Pribadi/Informasi Perusahaan Pengguna bersifat sukarela. Namun, bila Pengguna tidak
                    memberikan Data Pribadinya/Informasi Perusahaan kepada TruCarbon, TruCarbon tidak dapat memberikan
                    layanan-layanan atau produk- produk atau memproses pembayaran-pembayaran dari Pengguna.
                </li>
                <li>
                    Pengumpulan Data Pribadi/Informasi Perusahaan Pengguna terjadi saat Pengguna membuat atau melakukan
                    pembaruan Akun atau pada saat lainnya apabila dibutuhkan dari waktu ke waktu. TruCarbon akan
                    mengumpulkan Data Pribadi/Informasi Perusahaan Pengguna setiap kali Pengguna mengakses atau
                    menggunakan Aplikasi TruCarbon dan/atau Situs TruCarbon.
                </li>
                <li>
                    Apabila Pengguna menggunakan virtual akun yang disediakan oleh TruCarbon untuk menerima uang
                    elektronik dan/atau dompet digital dari pembayar, baik Pengguna adalah penyedia layanan ataupun
                    merchant, kami dapat mengumpulkan informasi tertentu sehubungan dengan penggunaan Anda termasuk
                    namun tidak terbatas pada layanan yang ditransaksikan, jumlah yang dikumpulkan Pengguna dari setiap
                    transaksi, penarikan atau rincian rekening penyelesaian dan penarikan atau riwayat penyelesaian.
                </li>
                <li>
                    Apabila Pengguna menggunakan dan/atau pada saat pembayaran terjadi melalui kartu atau akun yang
                    ditambahkan Pengguna ke dalam Aplikasi TruCarbon, TruCarbon dapat mengumpulkan informasi tertentu
                    sehubungan dengan riwayat transaksi (termasuk rincian penerimaan), rincian tagihan, rincian faktur,
                    dan nomor telepon.
                </li>
            </ol>
            <p>
                <strong>PENGGUNAAN DATA PRIBADI/INFORMASI PERUSAHAAN</strong>
            </p>
            <p>
                Adapun tujuan TruCarbon mengolah, menganalisis, dan/atau menggunakan Data Pribadi/Informasi Perusahaan
                Pengguna sesuai dan diizinkan oleh peraturan perundang-undangan yang berlaku, adalah sebagai berikut:
            </p>
            <ol>
                <li>
                    Mengidentifikasi dan mendaftarkan Pengguna sebagai pengguna Aplikasi TruCarbon dan/atau Situs
                    TruCarbon sekaligus melakukan verifikasi, menonaktifkan atau mengelola akun Pengguna, termasuk
                    proses Mengenal Pelanggan (Know Your Customer);
                </li>
                <li>
                    Memproses dan mengelola Aplikasi TruCarbon dan/atau Situs TruCarbon dan komponen-komponen terkait
                    Aplikasi TruCarbon dan/atau Situs TruCarbon Pengguna;
                </li>
                <li>
                    Mencegah, mendeteksi, menyelidiki dan mengurangi terjadinya tindakan kejahatan atau perbuatan
                    terlarang, ilegal, tidak sah, atau curang, yang mungkin terjadi dalam penggunaan Aplikasi TruCarbon
                    dan/atau Situs TruCarbon termasuk namun tidak terbatas pada penipuan (fraud), penggelapan, pencurian
                    dan pencucian uang;
                </li>
                <li>
                    Mengembangkan, menambah, dan menyediakan layanan dan/atau produk untuk memenuhi kebutuhan Pengguna;
                </li>
                <li>
                    Menyempurnakan pelaksanaan riset mengenai data demografis pengguna Aplikasi TruCarbon dan/atau Situs
                    TruCarbon;
                </li>
                <li>
                    Melakukan pengiriman informasi yang TruCarbon anggap bermanfaat bagi Pengguna setelah Pengguna
                    memberikan persetujuan kepada TruCarbon bahwa Pengguna tidak keberatan dihubungi mengenai layanan
                    TruCarbon;
                </li>
                <li>
                    Menggunakan Data Pribadi/Informasi Perusahaan Pengguna untuk tujuan administratif internal, termasuk
                    namun tidak terbatas pada ; audit, analisis data, rekaman-rekaman dalam database;
                </li>
                <li>
                    Melakukan komunikasi dengan Pengguna sehubungan dengan segala hal mengenai Aplikasi TruCarbon
                    dan/atau Situs TruCarbon, dan/atau fitur-fitur dari padanya sekaligus ikut menjaga keselamatan,
                    keamanan, dan keberlangsungan Aplikasi TruCarbon dan/atau Situs TruCarbon, layanan-layanan
                    TruCarbon, dan/atau fitur-fitur dari padanya;
                </li>
                <li>
                    Memungkinkan TruCarbon untuk menyediakan dan memproses layanan yang Pengguna minta atau transaksi
                    yang Pengguna lakukan.
                </li>
                <li>
                    Untuk keperluan akuntansi dan pelaporan keuangan, mengakses catatan pengguna.
                </li>
                <li>
                    Untuk pengembangan layanan TruCarbon dengan menggunakan teknologi machine learning dan penggunaan
                    data untuk menghitung emisi pengguna berdasarkan data akuntansi.
                </li>
                <li>
                    Untuk Mengumpulkan informasi tentang formula baru faktor emisi pengguna untuk pengguna lain dari
                    Aplikasi TruCarbon dan/atau Situs TruCarbon.
                </li>
                <li>
                    Akumulasi Data dari beberapa pengguna untuk digunakan untuk meningkatkan Aplikasi TruCarbon dan/atau
                    Situs TruCarbon, layanan TruCarbon, dan/atau fiturnya.
                </li>
            </ol>
            <p>
                <strong>KERJA SAMA PIHAK KETIGA</strong>
            </p>
            <p>
                Dalam memelihara aplikasi/situs web TruCarbon, TruCarbon bekerja sama/menggunakan layanan dari
                perusahaan pihak ketiga yang membantu dalam pemrosesan Data Pribadi/Informasi Perusahaan pengguna.
            </p>
            <p>
                <strong>TAUTAN KE SITUS PIHAK KETIGA</strong>
            </p>
            <p>
                Dengan menggunakan Aplikasi TruCarbon dan/atau Situs TruCarbon ini serta persetujuan atas Kebijakan
                Privasi ini, Pengguna telah memberikan ijin kepada TruCarbon untuk melakukan tautan ke situs pihak
                ketiga. TruCarbon tidak bertanggungjawab atas perolehan, pengumpulan, pengolahan, penganalisisan,
                penggunaan, penyimpanan, penampilan, pengumuman, pengiriman, penyebarluasan, penghapusan dan pemusnahan
                Data Pribadi/Informasi Perusahaan Pengguna oleh pihak ketiga tersebut. Demikian pula bila Pengguna
                memberikan informasi langsung ke situs tersebut, kebijakan privasi dan ketentuan layanan di situs
                tersebutlah yang akan berlaku, dan TruCarbon tidak bertanggung jawab atas kegiatan pengolahan informasi
                atau kebijakan privasi dari situs tersebut dan/ atau segala kerugian yang timbul dalam situs pihak
                ketiga tersebut
            </p>
            <p>
                <strong>KEAMANAN, PENYIMPANAN DAN PENGHAPUSAN DATA PRIBADI/INFORMASI PERUSAHAAN PENGGUNA</strong>
            </p>
            <ol>
                <li>
                    TruCarbon melindungi setiap Data Pribadi/Informasi Perusahaan yang disimpan dalam sistemnya serta
                    melindungi data tersebut dari akses, penggunaan, modifikasi, pengambilan yang tidak sah, termasuk
                    kata sandi dan kode OTP.
                </li>
                <li>
                    Walaupun TruCarbon sudah menggunakan upaya terbaiknya dalam menjaga Data Pribadi/Informasi
                    Perusahaan Pengguna, namun demikian, TruCarbon tidak dapat menjamin 100% keamanan data, dan menjadi
                    risiko bagi Pengguna sendiri
                </li>
                <li>
                    Setiap saat Pengguna menggunakan Aplikasi TruCarbon atau mengunjungi Situs TruCarbon, informasi
                    tertentu juga dapat dikumpulkan secara otomatis menggunakan cookies. Cookie adalah file aplikasi
                    kecil yang disimpan di komputer atau perangkat seluler Pengguna. Kami menggunakan cookie untuk
                    melacak aktivitas pengguna guna meningkatkan antarmuka dan pengalaman pengguna. Sebagian besar
                    perangkat seluler dan browser internet mendukung penggunaan cookie; namun Pengguna dapat
                    menyesuaikan pengaturan pada perangkat seluler atau browser internet mereka untuk menolak beberapa
                    jenis cookie tertentu atau seluruh cookie. Perangkat seluler dan/atau browser juga akan memungkinkan
                    Pengguna untuk menghapus kapan saja cookie apa pun yang sebelumnya telah disimpan. Meskipun
                    demikian, tindakan tersebut dapat memengaruhi fungsi yang tersedia di Aplikasi TruCarbon atau Situs
                    TruCarbon.
                </li>
                <li>
                    TruCarbon akan menghapus atau menganonimkan Data Pribadi/Informasi Perusahaan pengguna yang ada di
                    bawah kendali TruCarbon apabila Data Pribadi/Informasi Perusahaan tersebut sudah tidak diperlukan
                    untuk memenuhi tujuan pengumpulannya.
                </li>
            </ol>
            <p>
                <strong>PENGADUAN TERKAIT PERLINDUNGAN DATA PRIBADI/INFORMASI PERUSAHAAN PENGGUNA</strong>
            </p>
            <ol>
                <li>
                    Jika Pengguna memiliki kekhawatiran tentang penanganan atau perlakuan TruCarbon terhadap Data
                    Pribadi/Informasi Perusahaan pengguna atau jika pengguna yakin bahwa privasinya telah dilanggar,
                    Pengguna dapat menghubungi TruCarbon melalui layanan TruCarbon atau kepada kontak TruCarbon yang
                    tercantum dalam Kebijakan Privasi ini dengan menjelaskan identitas dan keluhan.
                </li>
                <li>
                    TruCarbon akan menyelidiki keluhan pengguna dan berupaya untuk memberikan tanggapan terhadap keluhan
                    tersebut dalam kurun waktu yang wajar setelah menerima keluhan yang disampaikan oleh Pengguna.
                </li>
            </ol>
            <p>
                <strong>KESELURUHAN PERJANJIAN</strong>
            </p>
            <p>
                Kecuali secara tegas disepakati secara tertulis oleh Para Pihak, Perjanjian ini merupakan keseluruhan
                perjanjian di antara Para Pihak sehubungan dengan hal-hal yang ditangani di sini dan menggantikan
                perjanjian sebelumnya di antara Para Pihak sehubungan dengan hal-hal tersebut.
            </p>
            <p>
                <strong>PERUBAHAN TERHADAP KEBIJAKAN PRIVASI</strong>
            </p>
            <ol>
                <li>
                    TruCarbon dapat untuk setiap saat mengubah, memperbarui, dan/atau menambahkan sebagian ataupun
                    seluruh ketentuan dalam Kebijakan Privasi ini, sesuai dengan bisnis TruCarbon ke depan, dan/atau
                    perubahan peraturan perundang-undangan yang berlaku. Bila perubahan atau penambahan tersebut
                    TruCarbon lakukan, TruCarbon akan memberitahu Pengguna melalui notifikasi yang disampaikan melalui
                        Aplikasi TruCarbon dan/atau situs{" "}
                    <a href="https://trucarbon.co" target="_blank" rel="noreferrer">
                        https://trucarbon.co
                    </a>{" "}
                    dan/atau ke alamat email Pengguna.
                </li>
                <li>
                    Dengan terus menggunakan Aplikasi TruCarbon maupun Situs TruCarbon berarti Pengguna telah menyetujui
                    perubahan, pembaharuan, dan/atau penambahan yang TruCarbon lakukan terhadap Kebijakan Privasi ini.
                </li>
                <li>
                    Jika Pengguna melanjutkan untuk menggunakan Aplikasi TruCarbon dan/atau Situs TruCarbon setelah
                    membaca Kebijakan Privasi ini, Pengguna telah menyetujui Kebijakan Privasi ini – termasuk
                    perubahannya – dan dapat melanjutkan penggunaan Aplikasi.
                </li>
            </ol>
            <p>
                <strong>PENGALIHAN BISNIS</strong>
            </p>
            <p>
                Dalam hal terjadi perubahan kendali atau perubahan kepemilikan atas semua atau sebagian dari TruCarbon
                atau perusahaan, termasuk situs, maka Data Pribadi/Informasi Perusahaan Pengguna mungkin/akan menjadi
                bagian dari pengalihan aset tersebut. Lebih lanjut TruCarbon akan menyampaikan dalam hal terjadinya
                penggabungan, pemisahan, pengambilalihan, peleburan atau pembubaran kepada Pengguna aplikasi TruCarbon.
            </p>
            <p>
                <strong>URUTAN PRIORITAS</strong>
            </p>
            <p>
                Jika Pengguna/Perusahaan telah menyetujui Perjanjian Pengguna kami, dalam hal terdapat perbedaan antara
                Perjanjian Pengguna tersebut dan Kebijakan Privasi ini terkait penggunaan data pribadi, maka Perjanjian
                Pengguna yang akan berlaku.
            </p>
            <p>
                <strong>HUBUNGI KAMI</strong>
            </p>
            <p>
                Dalam hal Pengguna memiliki pertanyaan, komentar atau klaim mengenai kebijakan privasi ini atau ingin
                mendapatkan akses atau koreksi terhadap Data Pribadinya/Informasi Perusahaan, silakan hubungi layanan
                pelanggan TruCarbon melalui{" "}
                <a href="mailto:contact@trucarbon.co" target="_blank" rel="noreferrer">
                    contact@trucarbon.co
                </a>
            </p>
        </div>
    );
}
